import { styled } from '@linaria/react'

export const PersonWrapper = styled.div`
  text-align: center;
  max-width: 250px;
  margin: 0 auto;

  @media screen and (max-width: 767.98) {
    max-width: 100%;
  }
`

export const PersonPhoto = styled.div`
  margin-bottom: 40px;

  img {
    width: 168px !important;
    height: 168px !important;
    border-radius: 50%;
    object-fit: cover;
    object-position: center;
    margin: 0 auto;
  }
`

export const PersonTitle = styled.h5`
  margin-bottom: 0;
`

export const PersonDesc = styled.p`
  margin-bottom: 0;
`
